import { useErrorContext } from "../../global/hooks/useErrorContext";
import { useDirectorySearchContext } from '../contexts/DirectorySearchContext';
import { IMember } from "../types/interfaces/IMember";
import { IFilterParams } from "../types/interfaces/IFilterParams";
import { FilterRequest } from "../types/classes/FilterRequest";


//This custom hook is responsible for making a POST request to the specified api endpoint. Api end point must return IMember[].
export default function usePostMembers() : (filterParams: IFilterParams, signal?: AbortSignal) => Promise<IMember[] | null> {
    const { setError } = useErrorContext();
    const { setLoadingFilteredList } = useDirectorySearchContext();
    const directory_members_data_api: string = process.env.REACT_APP_API_POST_DIRECTORY_MEMBERS!;

    const handleError = (message: string | null, statusCode: number) => {  
        setError({ message, statusCode });
        setLoadingFilteredList(false);
        return null;
    };

    function mapFilterParamsToRequest(filterParams: any): FilterRequest {
    const mapValue = (val: string | null | undefined) =>
        val === null || val === undefined || (typeof val === "string" && val.trim() === "") ? null : val;

    return {
        LastName: mapValue(filterParams.LastName),
        City: mapValue(filterParams.City),
        State: mapValue(filterParams.State),
        Zip: mapValue(filterParams.ZipCode),
        Country: mapValue(filterParams.Country),
        Specialty: mapValue(filterParams.Specialty),
        Interest: mapValue(filterParams.Interest),
        Language: mapValue(filterParams.Language),
    } as FilterRequest;
}

    const postMembersFetch = async (filterParams: IFilterParams, signal?: AbortSignal): Promise<IMember[] | null> => {
        try {
             setLoadingFilteredList(true);

           const filterRequest: FilterRequest = mapFilterParamsToRequest(filterParams);
        console.log("filterRequest: ", filterRequest);
            const response = await fetch(directory_members_data_api, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(filterRequest),
                signal, // Pass the signal here
            });
            if (!response.ok) {
                console.log('postMembersFetch', response.statusText);
                    return handleError(null, -11);
            }
            const result = await response.json();
            if (!result) {
                return handleError(null, -22);
            } else {
                if (result.Data === null || (!result.Succeeded && result.Errors !== null)) {
                    return handleError(null, -33);
                }
            }
            return result.Data;
        } catch (error: any) {
            console.log('postMembersFetch error', error);
            return handleError(null, -error.status);
        } finally {
			setLoadingFilteredList(false);
		}
    };

return (filterParams: IFilterParams, signal?: AbortSignal) => {
    return postMembersFetch(filterParams, signal);
};
}